// Validate email domain
export const validateEmailDomain = (email, allowed_domain) => {
  if (!email) return false;
  return email.toLowerCase().endsWith(`@${allowed_domain}`);
};

// Validate password requirements
export const validatePassword = (password) => {
  const errors = [];
  
  if (password.length < 8) {
    errors.push('at least 8 characters');
  }
  
  if (!/[A-Z]/.test(password)) {
    errors.push('one uppercase letter');
  }
  
  // eslint-disable-next-line no-useless-escape
  if (!/[!@#$%^&*(),.?":{}|<>_\-+=\[\]\\;'\`~]/.test(password)) {
    errors.push('one special character (!@#$%^&*...)');
  }
  
  return errors;
};

// Get password strength indicator
export const getPasswordStrength = (password) => {
  if (!password) return null;
  const errors = validatePassword(password);
  
  if (errors.length === 0) {
    return { color: '#16a34a', text: '✓ Password meets all requirements' };
  }
  
  return { 
    color: '#dc2626', 
    text: `Missing: ${errors.join(', ')}` 
  };
};
